module.exports = __webpack_public_path__ + "static/media/transportationManagementSystem-1.f3c0231e.svg";